import {
  ControlProps,
  isStringControl,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";
import {
  FormDetailItem,
  FormDetailValue,
  FormDetailWrapper,
} from "../../messageType/contentType/FormContent.style";

const StringViewRenderer = ({ data, label, uischema }: ControlProps) => {
  const { hideIfUndefined } = uischema.options || {};
  const shouldHide = hideIfUndefined && data === undefined;
  if (shouldHide) return <></>;
  return (
    <FormDetailWrapper data-testid="form-content-item">
      <FormDetailItem>{label} :</FormDetailItem>
      <FormDetailValue>{data}</FormDetailValue>
    </FormDetailWrapper>
  );
};

export const stringViewTester: RankedTester = rankWith(5, isStringControl);

export default withJsonFormsControlProps(StringViewRenderer);
